import { AxiosResponse } from 'axios';
import { GENERATE_OTP_URL, VERIFY_OTP_URL } from '../utils/environment';
import axiosInstance from '../utils/axiosInstance';

class AuthServices {
  static async sendOTP(mobileNumber: string | number): Promise<boolean> {
    try {
      if (
        mobileNumber == null ||
        (typeof mobileNumber !== 'string' && typeof mobileNumber !== 'number')
      ) {
        throw new Error('mobileNumber must be a string or number');
      }

      const data = {
        mobileNumber: mobileNumber,
      };

      const response: AxiosResponse = await axiosInstance.post(`${GENERATE_OTP_URL}`, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response?.data == null) {
        throw new Error('Response data is null');
      }

      return !!response.data;
    } catch (error) {
      console.error('Error in sendOTP: ', error);
      return false;
    }
  }

  static async verifyOTP(mobileNumber: string | number, otp: string): Promise<string | false> {
    try {
      if (
        mobileNumber == null ||
        (typeof mobileNumber !== 'string' && typeof mobileNumber !== 'number')
      ) {
        throw new Error('mobileNumber must be a string or number');
      }

      if (otp == null || typeof otp !== 'string') {
        throw new Error('OTP must be a string');
      }

      const data = {
        mobileNumber: mobileNumber,
        otp: otp,
      };

      const response: AxiosResponse<{ token: string }> = await axiosInstance.post(
        `${VERIFY_OTP_URL}`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (response?.data == null) {
        throw new Error('Response data is null');
      }

      return response.data.token;
    } catch (error) {
      console.error('Error in verifyOTP: ', error);
      return false;
    }
  }
}

export default AuthServices;
